import Vue from 'vue'
import Router from 'vue-router'
import { loadLanguageAsync } from './providers/i18n'
import Game from './views/Game.vue'
import Home from './views/Home.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/game/:lang/:sharedGameUri?',
      name: 'game',
      component: Game
    }
  ]
})

router.beforeEach((to, from, next) => {
  const lang = typeof to.params.lang !== 'undefined' ? to.params.lang : 'en'
  loadLanguageAsync(lang).then(() => next())
})

export default router
